import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsRunIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_run"}/>
}
